import Button from "../customComponents/Button";
import Paper from "../widgets/Paper";
import InputText from "../customComponents/InputText";
import Select from "../customComponents/Select";
import { useEffect, useState, useRef } from "react";
import UploadHotel from "../customComponents/UploadHotel";
import MultiUpload from "../customComponents/MultiUpload";
import RadioButton from "../customComponents/RadioButton";
import DatePicker from "../customComponents/DatePicker";
import { post } from "../utils/api";
import { useNavigate, useLocation } from "react-router-dom";
import Loader from "../widgets/Loader";
import { ToastContainer, toast } from "react-toastify";
import { MultiNewSelect } from "../customComponents/NewMultiSelect";
import useRepricePrompt from "./hooks/useRepricePrompt";

const AddHotel = () => {
  const location = useLocation();
  const { promptReprice, RepriceModal } = useRepricePrompt();
  const { hotelinfo, type } = location.state || {};
  const isEdit = !!hotelinfo?.hotelid;
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [selectedValue, setSelectedValue] = useState("single");
  const [selectedGrade, setSelectedGrade] = useState([]);
  const [selectedMealPlan, setSelectedMealPlan] = useState(null);
  const [showSeasonalFields, setShowSeasonalFields] = useState([]);
  const [seasonalMonthOptions, setSeasonalMonthOptions] = useState([]);
  const [selectedSeasonalMonth, setSelectedSeasonalMonth] = useState([]);
  const [hotelTypeOptions, setHotelTypeOptions] = useState([]);
  const [accommodationOptions, setAccommodationOptions] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [mealPlanOptions, setMealPlanOptions] = useState([]);
  const [selectedHotelType, setSelectedHotelType] = useState(null);
  const [selectedAccommodation, setSelectedAccommodation] = useState(null);
  const [hotelName, setHotelName] = useState("");
  const [city, setCity] = useState("");
  const [pricePerHead, setPricePerHead] = useState("");
  const [seasonalPrice, setSeasonalPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dropdownDataLoaded, setDropdownDataLoaded] = useState(false);
  // Coded by Akila
  const [propertyTypeRAC, setPropertyTypeRAC] = useState(false);
  const [propertyTypeIV, setPropertyTypeIV] = useState(false);
  const [propertyTypeHotels, setPropertyTypeHotels] = useState(false);
  const [propType, setPropType] = useState([]);
  const [error, setError] = useState(null);
  const hasFetched = useRef(false);
  const [weekOptions, setWeekOptions] = useState([]);
  const [selectedWeek, setSelectedWeek] = useState([]);
  const [seasonOptions, setSeasonOptions] = useState([]);
  const [selectedSeason, setSelectedSeason] = useState([]);
  const [hotelImages, setHotelImages] = useState([]);
  //get Hotel property type - Akila
  useEffect(() => {
    if (hasFetched.current) return; // Prevent duplicate API calls
    hasFetched.current = true;

    const fetchData = async () => {
      try {
        const response = await fetch("/getOptionList", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            type: "hoteltype",
            stateid: "",
          }),
        });

        if (!response.ok) throw new Error("Failed to fetch data");

        const result = await response.json();
        console.log("Full API Response:", result);
        setPropType(result);
      } catch (error) {
        setError(error.message);
      }
    };
    fetchData();
  }, []);
  // Temporary code
  // const seasonalMonth = [
  //   {
  //       "label": "January",
  //   },
  //   {
  //       "label": "February",
  //   },
  //   {
  //       "label": "March",
  //   },
  //   {
  //       "label": "April",
  //   },
  //   {
  //      "label": "May",
  //   },
  //   {
  //       "label": "June",
  //   },
  //   {
  //       "label": "July",
  //   },
  //   {
  //       "label": "August",
  //   },
  //   {
  //       "label": "September",
  //   },
  //   {
  //       "label": "October",
  //   },
  //   {
  //       "label": "November",
  //   },
  //   {
  //       "label": "December",
  //   }
  // ]

  // const showAccomodationType = [
  //   {
  //     "label": "Single Sharing",
  //   },
  //   {
  //       "label": "Double Sharing",
  //   },
  //   {
  //       "label": "Triple Sharing",
  //   },
  //   {
  //       "label": "Quad Sharing",
  //   }
  // ]

  // const weekOptions = [
  //   {
  //     "label": "Weekdays",
  //   },
  //   {
  //       "label": "Weekends",
  //   }
  // ]

  // const season = [
  //   {
  //     "label": "Off-season",
  //   },
  //   {
  //       "label": "Peak season",
  //   }
  // ]

  console.log("Aaa", propType);
  const [fields, setFields] = useState([
    {
      accommodationType: "",
      mealPlan: "",
      pricePerHead: "",
      seasonalPrice: "",
      weekVal: { label: "Weekdays", value: "Weekdays" },
      seasonsVal: { label: "Off-season", value: "Off-season" },
      seasonalMonth: ""
      //showSeasonalFields: ""
      // seasonValue: { label: "Weekdays", value: "Weekdays"  }
    },
  ]);




  // const handleFieldChange = (index, field, value) => {
  //   const updatedFields = [...fields];
  //   updatedFields[index][field] = value;
  //   setFields(updatedFields);
  // };

  // const addNewFieldSet = (index) => {
  //   const updatedFields = [...fields];
  //   // Add a new fieldset below the current one
  //   updatedFields.splice(index + 1, 0, {
  //     accommodationType: "",
  //     mealPlan: "",
  //     pricePerHead: "",
  //   });
  //   setFields(updatedFields);
  // };
  const addNewFieldSet = (index) => {
    setFields((prevFields) => {
      const newField = {
        accommodationType: "",
        mealPlan: "",
        pricePerHead: "",
      };

      // Create new array with empty field inserted after current index
      const updatedFields = [
        ...prevFields.slice(0, index + 1),
        newField,
        ...prevFields.slice(index + 1),
      ];

      return updatedFields;
    });
  };

  const deleteFieldSet = (index) => {
    const updatedFields = [...fields];
    if (updatedFields.length > 1) {
      updatedFields.splice(index, 1);
      setFields(updatedFields);
    }
  };

  useEffect(() => {
    const fetchAllOptions = async () => {
      try {
        await Promise.all([
          fetchHotelType(),
          fetchAccommodationType(),
          fetchGrade(),
          fetchMealPlan(),
          fetchWeekOption(),
          fetchSeasonalMonth(),
          fetchSeasonOptions()
        ]);
        setDropdownDataLoaded(true); // Mark options as loaded
      } catch (error) {
        console.error("Error fetching dropdown options:", error);
      }
    };

    fetchAllOptions();
  }, []);

  // useEffect(() => {
  //   fetchHotelType();
  //   fetchAccommodationType();
  //   fetchGrade();
  //   fetchMealPlan();
  // }, []);

  useEffect(() => {
    if (isEdit && dropdownDataLoaded) {
      prePopulateValue(); // Now dropdown options are ready
    }
  }, [dropdownDataLoaded]);

  const prePopulateValue = async () => {
    try {
      console.log("hotelinfo:", hotelinfo);

      const selectedHotelType = hotelinfo?.hoteltype || "";

      // Define Property Type Conditions
      const propertyTypeRACList = ["Resort", "Amusement Park", "Campsite"];
      const propertyTypeIVList = ["Industrial Visit"];
      const propertyTypeHotelsList = [
        "Deluxe Hotels",
        "3 Star Hotels / Resort Basic",
        "3 star hotels / Resort -Deluxe",
        "4 Star Hotels / Resort Basic",
        "4 Star Hotels / Resort Deluxe",
        "5 Star Hotels"
      ];
      // Update State for UI Hiding based on Edit Mode Data
      setPropertyTypeRAC(propertyTypeRACList.includes(selectedHotelType));
      setPropertyTypeIV(propertyTypeIVList.includes(selectedHotelType));
      setPropertyTypeHotels(propertyTypeHotelsList.includes(selectedHotelType));

      // Process Grade IDs
      // const userInstitutionIds = hotelinfo?.gradeid
      //     ? Array.isArray(hotelinfo?.gradeid)
      //         ? hotelinfo?.gradeid
      //         : hotelinfo?.gradeid.replace(/[{}]/g, "").split(",").map(id => id.trim())
      //     : [];

      // console.log("Processed userInstitutionIds:", userInstitutionIds);

      // const validGradeOptions = Array.isArray(gradeOptions) ? gradeOptions : [];
      // const selectedGrade = validGradeOptions.filter((list) =>
      //     userInstitutionIds.includes(list.id?.toString())
      // );

      // Set Other Fields
      setSelectedGrade(selectedGrade);
      setSelectedWeek(selectedWeek);
      setSelectedSeason(selectedSeason);
      setSelectedSeasonalMonth(hotelinfo?.hotelwise_plan?.[0]?.seasonalMonth || []);
      setSelectedHotelType(selectedHotelType);
      setSelectedMealPlan(hotelinfo?.mealPlan);
      setSeasonalPrice(hotelinfo?.season_priceperhead);
      setCity(hotelinfo?.city);
      setHotelName(hotelinfo?.hotelname);
      setStartDate(hotelinfo?.seasonstart ? new Date(hotelinfo?.seasonstart) : null);
      setEndDate(hotelinfo?.seasonend ? new Date(hotelinfo?.seasonend) : null);
      setFields(hotelinfo?.hotelwise_plan || []);
      const raw = hotelinfo?.hotel_image;
      if (Array.isArray(raw)) {
        setHotelImages(raw);
      } else if (raw) {
        setHotelImages([raw]);
      } else {
        setHotelImages([]);
      }

    } catch (error) {
      console.error("Error in prePopulateValue:", error);
    }
  };

  const fetchHotelType = async () => {
    try {
      const payload = { type: "hoteltype" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.hoteltypeid,
        })),
      ];
      setHotelTypeOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchSeasonalMonth = async () => {
    try {
      const payload = { type: "seasonal_month" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.seasonalmonthid,
        })),
      ];
      setSeasonalMonthOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchAccommodationType = async () => {
    try {
      const payload = { type: "accommodationtype" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.accommodationtypeid,
        })),
      ];
      setAccommodationOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchGrade = async () => {
    try {
      const payload = { type: "grade" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.gradeid,
        })),
      ];
      setGradeOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchWeekOption = async () => {
    try {
      const payload = { type: "week_option" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.gradeid,
        })),
      ];
      setWeekOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchSeasonOptions = async () => {
    try {
      const payload = { type: "season" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.gradeid,
        })),
      ];
      setSeasonOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const fetchMealPlan = async () => {
    try {
      const payload = { type: "mealplan" };
      const result = await post("/getOptionList", payload);
      const options = [
        ...result.data.map((list) => ({
          label: list.label,
          value: list.label,
          id: list.mealplanid,
        })),
      ];
      setMealPlanOptions(options);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleRadioChange = (event) => {
    setSelectedValue(event.target.value);
  };

  const handleDateChange = (date, type) => {
    if (type == "startdate") {
      setStartDate(date);
    } else {
      setEndDate(date);
    }
  };

  const handleFormSelection = (e, type) => {
    let value = Array.isArray(e) ? e : e?.value; console.log("WAAA", value);
    console.log("type", type, "oooo", value);
   /* if (type == "grade") {
      setSelectedGrade(e);
    } else if (type == "mealPlan") { 
      setSelectedMealPlan(e);
    } else */ if (type == "hoteltype") {
      setSelectedHotelType(value);
      setPropertyTypeRAC(value == "Resort" || value == "Amusement Park" || value == "Campsite");
      setPropertyTypeIV(value == "Industrial Visit");
      setPropertyTypeHotels(value == "Deluxe Hotels" || value == "3 Star Hotels / Resort Basic" || value == "3 star hotels / Resort -Deluxe" || value == "4 Star Hotels / Resort Basic" || value == "4 Star Hotels / Resort Deluxe" || value == "5 Star Hotels");
    } /*else if (type == "accomodationType") {
      setSelectedAccommodation(e);
    } */ else if (type == "seasonalMonth") {
      setSelectedSeasonalMonth(value);
    }
  };

  const handleChange = (e, type) => {
    let value = e.target.value;
    if (type == "hotelname") {
      setHotelName(value);
    } else if (type == "city") {
      setCity(value);
    } else if (type == "priceperhead") {
      setPricePerHead(value);
    } else if (type == "seasonalprice") {
      setSeasonalPrice(value);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    try {
      if (!selectedHotelType) {
        toast.error("Hotel Type is required");
        return;
      }

      if (!hotelName) {
        toast.error("Hotel name is required");
        return;
      }

      if (!city) {
        toast.error("City is required");
        return;
      }

      // debugger
      //       if(!accommodationType){
      //         toast.error("Accommodation Type is required");
      //         return
      //       };

      //       if(!selectedMealPlan){
      //         toast.error("Meal Plan is required");
      //         return
      //       }
      //       if(!pricePerHead){
      //         toast.error("Price per head is required");
      //         return
      //       };
      const excludedRACTypes = ["Resort", "Amusement Park", "Campsite"];
      const isExcludedRACType = excludedRACTypes.includes(selectedHotelType);
      const isExcludedIndustrialVisitType = selectedHotelType === "Industrial Visit";
      const excludedStarHotels = ["Deluxe Hotels", "3 Star Hotels / Resort Basic", "3 star hotels / Resort -Deluxe", "4 Star Hotels / Resort Basic", "4 Star Hotels / Resort Deluxe", "5 Star Hotels"]
      const isExcludedStarHotels = excludedStarHotels.includes(selectedHotelType);

      if (isExcludedRACType || isExcludedIndustrialVisitType) {
        // if (!selectedGrade || selectedGrade.length === 0) {
        //   toast.error("Please select at least one Grade");
        //   setLoading(false);
        //   return;
        // }
        fields.forEach((field, index) => {
          if (!field.grade) {
            throw new Error(`grade is required for plan ${index + 1}.`);
          }
        });
      }
      if (isExcludedStarHotels) {
        fields.forEach((field, index) => {
          if (!field.accommodationType) {
            throw new Error(`Accommodation Type is required for plan ${index + 1}.`);
          }
          if (!field.mealPlan) {
            throw new Error(`Meal Plan is required for plan ${index + 1}.`);
          }
        });
      }
      if (isExcludedRACType || isExcludedStarHotels) {
        fields.forEach((field, index) => {
          if (!field.mealPlan) {
            throw new Error(`Meal Plan is required for plan ${index + 1}.`);
          }
        });
      }
      if (isExcludedRACType || isExcludedIndustrialVisitType || isExcludedStarHotels) {
        fields.forEach((field, index) => {
          const value = field.pricePerHead?.trim();
          if (!value || isNaN(value) || Number(value) <= 0) {
            throw new Error(`Price Per Head is required and must be a valid number for plan ${index + 1}.`);
          }
        });
      }
      //   // if (!pricePerHead || pricePerHead.trim() === "") {
      //   //     toast.error("Price per head is required");
      //   //     return;
      //   // }
      // }
      // if (!isExcludedType)  {
      //   fields.forEach((field, index) => {
      //     if (!field.accommodationType || field.accommodationType.trim() === "") {
      //       throw new Error(
      //         `Accommodation Type is required for plan ${index + 1}.`
      //       );
      //     }
      //     if (!field.mealPlan || field.mealPlan.trim() === "") {
      //       throw new Error(`Meal Plan is required for plan ${index + 1}.`);
      //     }
      //     if (!field.pricePerHead || field.pricePerHead.trim() === "") {
      //       throw new Error(`Price Per Head is required for plan ${index + 1}.`);
      //     }
      //   });
      // }
      // if (!isExcludedType)  {
      //   fields.forEach((field, index) => {
      //     // if (!field.accommodationType || field.accommodationType.trim() === "") {
      //     //   throw new Error(
      //     //     `Accommodation Type is required for plan ${index + 1}.`
      //     //   );
      //     // }
      //     if (!field.mealPlan || field.mealPlan.trim() === "") {
      //       throw new Error(`Meal Plan is required for plan ${index + 1}.`);
      //     }
      //     if (!field.pricePerHead || field.pricePerHead.trim() === "") {
      //       throw new Error(`Price Per Head is required for plan ${index + 1}.`);
      //     }
      //   });
      // }

      if (!isExcludedRACType && selectedSeasonalMonth && !isExcludedIndustrialVisitType && !isExcludedStarHotels) {
        if (!startDate) {
          toast.error("Season start date is required");
          return;
        }

        if (!endDate) {
          toast.error("Season end date is required");
          return;
        }
        if (!seasonalPrice) {
          toast.error("Seasonal price is required");
          return;
        }
      }
      const payload = {
        // gradeid: selectedGrade.map(
        //   (grade) => gradeOptions.find((opt) => opt.label === grade.value)?.id
        // ),
        gradeid: Array.isArray(selectedGrade)
          ? `{${selectedGrade.map((opt) => opt?.id).join(",")}}`
          : selectedGrade?.id
            ? `{${selectedGrade.id}}`
            : null,
        mealplanid: mealPlanOptions.filter(
          (list) => list.label == selectedMealPlan
        )?.[0]?.id,
        hoteltypeid: hotelTypeOptions.filter(
          (list) => list.label == selectedHotelType
        )?.[0]?.id,
        accommodationtypeid: accommodationOptions.filter(
          (list) => list.label == selectedAccommodation
        )?.[0]?.id,
        seasonstart: startDate,
        seasonend: endDate,
        hotelname: hotelName,
        city: city,
        priceperhead: pricePerHead,
        season_priceperhead: seasonalPrice,
        type: hotelinfo?.hotelid ? "update" : "insert",
        hotelid: hotelinfo?.hotelid,
        seasonalMonth: selectedSeasonalMonth.map((m) => m.value).join(","), // Just in case you want to send comma-separated
        hotelwise_planVal: fields.map((f) => ({
          ...f,
          seasonalMonth: selectedSeasonalMonth,
        })),
        hotel_image: hotelImages,
      };

      // hotelwise_planVal
      const response = await post("/addHotel", payload);
      toast.success(
        hotelinfo?.hotelid
          ? "Property updated successfully!"
          : "Property added successfully!"
      );
      promptReprice(response, () =>
        setTimeout(() => {
          navigate("/hotels");
        }, 2000)
      );
    } catch (error) {
      toast.error(error.message || "An error occurred while adding the property."); // Show toast error message for any exceptions
    } finally {
      setLoading(false);
    }
  };

  const hotelwiseHandleChange = (e, index, fieldName) => {
    setFields((prevFields) => {
      const updatedFields = [...prevFields];
      if (["grade", "mealPlan", "accommodationType", "weekVal", "seasonsVal"].includes(fieldName)) {
        updatedFields[index] = {
          ...updatedFields[index],
          [fieldName]: e || null,
        };

        if (fieldName === "grade") {
          setSelectedGrade(e || null);
        } else if (fieldName === "mealPlan") {
          setSelectedMealPlan(e || null);
        } else if (fieldName === "accommodationType") {
          setSelectedAccommodation(e || null);
        } else if (fieldName === "weekVal") {
          setSelectedWeek(e || null);
        } else if (fieldName === "seasonsVal") {
          setSelectedSeason(e || null);
        }
      }
      else {
        updatedFields[index] = {
          ...updatedFields[index],
          [fieldName]: e?.target?.value ? e.target.value : e.value,
        };
      }
      return updatedFields;
    });

    if (fieldName === "seasonalPrice") {
      setSeasonalPrice(e?.target?.value || "");
    }

  };


  return (
    <div>
      {RepriceModal}
      {loading ? <Loader /> : <></>}
      <div className="flex justify-between">
        <div>
          <h2 className="text-primary-black text-[24px] font-semibold">
            Properties
          </h2>
          <p className="text-[12px]">
            <span className="font-bold">Properties</span> /
            <span className="font-regular">Add Property</span>
          </p>
        </div>

        <div className="flex gap-4">
          {hotelinfo?.hotelid ? (
            <Button type="primary" label="Update" onClick={handleSave} />
          ) : (
            <Button type="primary" label="Save" onClick={handleSave} />
          )}
          <Button
            type="secondary"
            label="Cancel"
            onClick={() => navigate("/hotels")}
          />
        </div>
      </div>
      <Paper className="my-8 pt-6 pb-6">
        <h1 className="text-[16px] font-semibold">Upload Type</h1>
        <div className="mt-4 space-y-4">
          <RadioButton
            name="customRadio"
            value="single"
            checked={selectedValue === "single"}
            onChange={handleRadioChange}
            label="Single Upload"
          />
          <RadioButton
            name="customRadio"
            value="bulk"
            checked={selectedValue === "bulk"}
            onChange={handleRadioChange}
            label="Bulk Upload"
            className={"ml-4"}
          />
        </div>
        {selectedValue === "single" && (
          <>
            <Paper className="my-8 border">
              <h1 className="text-[20px] font-bold mb-4">Property Details</h1>
              <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    Property Type<span className="text-red-500">*</span>
                  </label>
                  <Select
                    placeholder="Select Type..."
                    options={hotelTypeOptions}
                    onChange={(e) => handleFormSelection(e, "hoteltype")}
                    value={hotelTypeOptions.find(
                      (option) => option.value === selectedHotelType
                    )}
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold">
                    Property Name<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    placeholder="Enter Hotel Name..."
                    value={hotelName}
                    onChange={(e) => handleChange(e, "hotelname")}
                  />
                </div>
                <div>
                  <label className="text-[16px] font-semibold mb-2">
                    City (Destination)<span className="text-red-500">*</span>
                  </label>
                  <InputText
                    placeholder="Enter City..."
                    onChange={(e) => handleChange(e, "city")}
                    value={city}
                  />
                </div>

                <div className="col-span-1 md:col-span-2 lg:col-span-4">
                  <label className="text-[16px] font-semibold mb-2 block">
                    Property Images <span className="text-gray-400 text-[12px] font-normal">(max 10, images only, 300KB each)</span>
                  </label>
                  <MultiUpload
                    images={hotelImages}
                    onChange={setHotelImages}
                    uploadEndpoint="/api/dashboard/upload/hotel-image"
                    labelText="Add Images"
                  />
                </div>

              </div>
              {!propertyTypeRAC && !propertyTypeIV && (
                <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-4 mt-6">
                  <div>
                    <label className="text-[16px] font-semibold mb-2">
                      Select the Seasonal Months:
                    </label>
                  </div>
                  <div>
                    <div className="mb-4">
                      <MultiNewSelect
                        options={seasonalMonthOptions}
                        value={selectedSeasonalMonth}
                        placeHolder="Select Months..."
                        isMulti={true}
                        onChange={(e) => {
                          setSelectedSeasonalMonth(e);
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}

              <div className="grid">
                <div
                  className=" items-center rounded-xl border-gray-300 p-4 mt-4 mb-2 border "
                >
                  <h1 className="text-[18px] font-bold mb-2 mt-2">Select Options</h1>
                  {fields?.map((field, index) => (
                    <div
                      key={index}
                      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4"
                    >
                      {/* Accommodation Plan */}
                      {!propertyTypeRAC && !propertyTypeIV && (
                        <div>
                          <label className="text-[16px] font-semibold">
                            Accommodation Type<span className="text-red-500">*</span>
                          </label>
                          <Select
                            options={accommodationOptions}
                            placeholder="Select Accommodation Type..."
                            onChange={(e) =>
                              hotelwiseHandleChange(e, index, "accommodationType")
                            }
                            value={field.accommodationType}
                          />
                        </div>
                      )}
                      {/* Grade */}
                      {!propertyTypeHotels && (
                        <div>
                          <label className="text-[16px] font-semibold">
                            Grade<span className="text-red-500">*</span>
                          </label>
                          <MultiNewSelect
                            options={gradeOptions}
                            //value={selectedGrade}
                            placeHolder="Select Grade..."
                            //onChange={(e) => handleFormSelection(e, "grade")}
                            isMulti={true}
                            onChange={(e) =>
                              hotelwiseHandleChange(e, index, "grade")
                            }
                            value={field.grade}
                          />
                        </div>
                      )}
                      {/* Meal Plan */}
                      {!propertyTypeIV && (
                        <div>
                          <label className="text-[16px] font-semibold">
                            Meal Plan<span className="text-red-500">*</span>
                          </label>
                          <Select
                            options={mealPlanOptions}
                            //value={selectedMealPlan}
                            placeholder="Select Meal Plan..."
                            //onChange={(e) => handleFormSelection(e, "mealPlan")}
                            onChange={(e) =>
                              hotelwiseHandleChange(e, index, "mealPlan")
                            }
                            value={field.mealPlan}
                          />
                        </div>
                      )}

                      {/* Week Option */}
                      {!propertyTypeHotels && (
                        <div>
                          <label className="text-[16px] font-semibold">
                            Week Option
                          </label>
                          <MultiNewSelect
                            options={weekOptions}
                            value={field.weekVal}
                            placeHolder="Select Week Option..."
                            onChange={(e) => hotelwiseHandleChange(e, index, "weekVal")}
                            isMulti={true}
                          />
                        </div>
                      )}
                      {!propertyTypeRAC && !propertyTypeIV && (
                        <div>
                          <label className="text-[16px] font-semibold">
                            Season
                          </label>
                          <MultiNewSelect
                            options={seasonOptions}
                            value={field.seasonsVal}
                            placeHolder="Select Season..."
                            onChange={(e) => hotelwiseHandleChange(e, index, "seasonsVal")}
                            isMulti={true}
                          />
                        </div>
                      )}

                      {/* Price per head */}
                      <div>
                        <label className="text-[16px] font-semibold">
                          Price per head (INR)
                          <span className="text-red-500">*</span>
                        </label>
                        <InputText
                          placeholder="Enter Price..."
                          onChange={(e) =>
                            hotelwiseHandleChange(e, index, "pricePerHead")
                          }
                          value={field.pricePerHead}
                        />
                      </div>
                      {/* Buttons */}
                      <div className="flex pt-6">
                        {index === fields.length - 1 ? (
                          <button
                            className="p-2 rounded bg-black text-white flex justify-center items-center"
                            onClick={() => addNewFieldSet(index)}
                          >
                            <span className="material-symbols-outlined">add</span>
                          </button>
                        ) : (
                          <button
                            className="p-2 rounded bg-red-500 text-white flex justify-center items-center"
                            onClick={() => deleteFieldSet(index)}
                          >
                            <span className="material-symbols-outlined">
                              delete
                            </span>
                          </button>
                        )}
                      </div>

                    </div>
                  ))}
                </div>

              </div>
            </Paper>
          </>
        )}
        <ToastContainer />

        {selectedValue === "bulk" && (
          <Paper className="my-8 border">
            <h1 className="text-[20px] font-bold mb-4">Upload File</h1>
            <UploadHotel />
          </Paper>
        )}
      </Paper>
    </div>
  );
};

export default AddHotel;
